import { Grid, Tabs } from 'antd';
import React from 'react';
import { useMatch, useResolvedPath } from 'react-router-dom';
import { ActiveCaseListContainer } from './active-case-list-container';
import { ArchivedCaseListContainer } from './archived-case-list-container';

export const formatCamelCase = (camelCaseString: string) => {
  return camelCaseString
    .replace(/caseWorker/g, 'Caseworker')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, (str) => str.toUpperCase());
};

interface CaseListProps {}

export const CaseList: React.FC<CaseListProps> = () => {
  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs;
  const caseListRoutePath = useResolvedPath('');
  const archivedCaseRouteMatch = useMatch(`${caseListRoutePath.pathname}/:caseType/:caseId/archived`);

  const items = [
    {
      key: 'Active',
      label: 'Active',
      children: (
        <div>
          <ActiveCaseListContainer />
        </div>
      )
    },
    {
      key: 'Archived',
      label: 'Archived',
      children: (
        <div>
          <ArchivedCaseListContainer />
        </div>
      )
    }
  ];

  return <Tabs defaultActiveKey={archivedCaseRouteMatch ? 'Archived' : 'Active'} centered style={isMobile ? { width: '100%', justifyContent: 'center' } : {}} items={items} />;
};

